import { Col, Container, Row } from 'react-grid-system';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { Button } from '../atoms';
import { useUserLanguage } from '@/customHooks';
import { useGetManagerMassiveCommunicationsQuery } from '@/graphql/generated';
import { CommunicationsListTable } from '../organism';
import { LoadingSpinner } from '../atoms';
import { pathURL } from '@/components/constants/urls';
import textsData from '@/textData/CommunicationsListTexts.json';

import communicationsEmptyStateImg from '@/assets/communications-empty-state.png';
import smsEditIcon from '@/assets/communication-icons/sms-edit.svg';

const ButtonContainer = styled(Col)`
  display: flex;
  align-items: center;
`;

const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
`;

const EmptyStateImage = styled.img`
  max-width: 280px;
  height: auto;
  margin-bottom: 1.5rem;
`;

const EmptyStateTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: ${({ theme }) => theme.colors.text};
`;

const EmptyStateSubtitle = styled.p`
  font-size: 0.95rem;
  color: #666;
  margin: 0 0 1.5rem;
`;

export const CommunicationsListPage = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;
  const navigate = useNavigate();

  const { data, loading } = useGetManagerMassiveCommunicationsQuery({
    fetchPolicy: 'network-only',
  });

  const communications = data?.managerMassiveCommunications ?? [];
  const hasCommunications = communications.length > 0;

  const handleCreateMessage = () => {
    navigate(`/${pathURL.USER}/${pathURL.COMMUNICATIONS}/${pathURL.CREATE}`);
  };

  return (
    <Container fluid>
      <Row align="center" justify="between">
        <Col>
          <h2>{texts.title}</h2>
        </Col>
        <ButtonContainer xs="content">
          <Button onClick={handleCreateMessage}>
            <img src={smsEditIcon} alt="" style={{ width: 18, height: 18, marginRight: 8, display: 'inline-block', verticalAlign: 'middle' }} />
            {texts.createButton}
          </Button>
        </ButtonContainer>
      </Row>

      {loading ? (
        <Row justify="center" style={{ paddingTop: '3rem' }}>
          <Col xs="content">
            <LoadingSpinner text />
          </Col>
        </Row>
      ) : hasCommunications ? (
        <Row>
          <Col>
            <CommunicationsListTable communications={communications} />
          </Col>
        </Row>
      ) : (
        <Row>
          <Col>
            <EmptyStateWrapper>
              <EmptyStateImage src={communicationsEmptyStateImg} alt="" />
              <EmptyStateTitle>{texts.emptyTitle}</EmptyStateTitle>
              <EmptyStateSubtitle>{texts.emptySubtitle}</EmptyStateSubtitle>
              <Button onClick={handleCreateMessage}>
                <img src={smsEditIcon} alt="" style={{ width: 18, height: 18, marginRight: 8, display: 'inline-block', verticalAlign: 'middle' }} />
                {texts.createButton}
              </Button>
            </EmptyStateWrapper>
          </Col>
        </Row>
      )}
    </Container>
  );
};
